var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.49988 1.5H7.49997H8.49988H8.49997V3.50001H9.49991H10.4998H10.4999V10.5H10.4998V10.5H3.49982V10.5V9.50002V8.50005H1.49988V8.5V7.50005V2.5V1.5H2.49988ZM7.49997 3.50001V2.5H2.49988V7.50005H3.49982V4.50001V3.50001H4.49982H7.49997ZM4.49982 8.50005V9.50002H9.49991V4.50001H4.49982V7.50005H4.49988V8.50005H4.49982Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyS);
export default __webpack_public_path__ + "static/media/copy-s.72747c422befac30b40e740ad10c1195.svg";
export { ForwardRef as ReactComponent };